<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="省份" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="province">
              <a-select  placeholder="请选择省份" v-model="model.province"
               @change="backProvince" >
                <a-select-option
                  v-for="d in provinceOptions"
                  :key="d.id"
                  :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="城市" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="city">
              <a-select  placeholder="请选择城市" @change="backCity"  v-model="model.city">
                <a-select-option
                  v-for="d in cityOptions"
                  :key="d.id"
                  :value="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="厂区编码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="code">
              <a-input v-model="model.code" @change="backFactoryCode" placeholder="请输入厂区编码"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="厂区名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="name">
              <a-input v-model="model.name"  @change="backFactoryName"  placeholder="请输入厂区名称"  ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JCategorySelectPrevent from './JCategorySelectPrevent'

  export default {
    name: 'PreFactoryForm',
    components: {
      JCategorySelectPrevent
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        pCategoryOptions:[],
        provinceOptions:[],
        cityOptions:[],
        validatorRules: {
           code: [
              { required: true, message: '请输入厂区编码!'},
           ],
           name: [
              { required: true, message: '请输入厂区名称!'},
           ],
           province: [
              { required: true, message: '请输入省份!'},
           ],
           city: [
              { required: true, message: '请输入城市!'},
           ],
           delFlag: [
              { required: true, message: '请输入是否删除!'},
           ],
        },
        url: {
          list: "/prevent/category/categoryList",
          add: "/prevent/factory/factoryAdd",
          edit: "/prevent/factory/factoryEdit",
          queryById: "/prevent/factory/prefactory/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
      this.loadData();
    },
    methods: {
      loadData(){
        this.loading = true
        let params = {pageNo:1,pageSize:100000};
        return new Promise((resolve) => {
          getAction(this.url.list,params).then(res=>{
            if(res.success){
              let result = res.result
              if(Number(result.total)>0){                                       
                this.provinceOptions = result.records.map(item=>{
                  if(item.pid == "0")
                  {
                    let c ={id:item.id, name: item.name}
                    return c;
                  }
                });              
              }
            }else{
              this.$message.warning(res.message)
            }
          }).finally(()=>{
            this.loading = false
          })
        })
      },
      backProvince()
      {
        this.cityOptions=[];    
        this.model.city = "";
        let params = {pid:this.model.province,pageNo:1,pageSize:100000};
        return new Promise((resolve) => {
          getAction(this.url.list,params).then(res=>{
            if(res.success){
              let result = res.result
              if(Number(result.total)>0){                     
                this.cityOptions = result.records.map(item=>{
                  if(item.pid == this.model.province)
                  {
                      let c ={id:item.id, name: item.name}
                      return c;
                  }
                });              
              }
            }else{
              this.$message.warning(res.message)
            }
          }).finally(()=>{
            this.loading = false
          })
        })
      },
      backCity()
      {
        this.$forceUpdate();
      },
      backFactoryCode()
      {
        this.$forceUpdate();
      },
      backFactoryName()
      {
        this.$forceUpdate();
      },
      add () {        
        //this.edit(this.modelDefault);
      },
      edit (record) {        
        this.model = Object.assign({}, record);
        this.visible = true;
        let params = {pid:this.model.province,pageNo:1,pageSize:100000};
        return new Promise((resolve) => {
          getAction(this.url.list,params).then(res=>{
            if(res.success){
              let result = res.result
              if(Number(result.total)>0){                                       
                this.cityOptions = result.records.map(item=>{
                  if(item.pid == this.model.province)
                  {
                    let c ={id:item.id, name: item.name}
                    return c;
                  }
                });              
              }
            }else{
              this.$message.warning(res.message)
            }
          }).finally(()=>{
            this.loading = false
          })
        })
        
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
